import { render, staticRenderFns } from "./useksnackbar.vue?vue&type=template&id=54402a7a&scoped=true"
import script from "./useksnackbar.vue?vue&type=script&lang=js"
export * from "./useksnackbar.vue?vue&type=script&lang=js"
import style0 from "./useksnackbar.vue?vue&type=style&index=0&id=54402a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54402a7a",
  null
  
)

export default component.exports